<template>
  <a-button style="width: 150px" @click="showI18nMessageModal">
    <template #icon>
        <EditOutlined />
    </template>
    變更多語系訊息
  </a-button>
  <a-modal v-model:open="isOpen" width="690px" :title="formTitle"
      :centered="isModalCentered" :maskClosable="isMaskClosable" 
      :closable="isMaskClosable" okText="確認" cancelText="關閉" 
      @cancel="cancelUpdateMessages" @ok="updateMessages">
    <a-divider />
    <a-form ref="i18nMessageForm" :model="formState" name="basic" :rules="formRules" 
        :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-form-item ref="messageZhTw" label="中文顯示訊息" name="messageZhTw">
        <a-input v-model:value="formState.messageZhTw" />
      </a-form-item>
      <a-form-item ref="messageEnUs" label="英文顯示訊息" name="messageEnUs">
        <a-input v-model:value="formState.messageEnUs" />
      </a-form-item>
      <a-form-item ref="messageThTh" label="泰文顯示訊息" name="messageThTh">
        <a-input v-model:value="formState.messageThTh" />
      </a-form-item>
      <a-form-item ref="messageViVn" label="越南文顯示訊息" name="messageViVn">
        <a-input v-model:value="formState.messageViVn" />
      </a-form-item>
      <a-form-item ref="messageIdId" label="印尼文顯示訊息" name="messageIdId">
        <a-input v-model:value="formState.messageIdId" />
      </a-form-item>
      <a-form-item ref="messageJaJp" label="日文顯示訊息" name="messageJaJp">
        <a-input v-model:value="formState.messageJaJp" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import { EditOutlined } from "@ant-design/icons-vue";
import { ref, reactive, defineProps, defineEmits } from 'vue';

const props = defineProps(['title', 'message']);
const emit = defineEmits(['cancel', 'update-complete']);

const i18nMessageForm = ref();
const isOpen = ref(false);
const formTitle = ref('');
const formState = reactive({});
const isModalCentered = ref(true);
const isMaskClosable = ref(false);

const formRules = {
  messageZhTw: [{
    required: true,
    message: '請輸入中文顯示訊息',
    trigger: ['blur']
  }],
  messageEnUs: [{
    required: true,
    message: '請輸入英文顯示訊息',
    trigger: ['blur']
  }],
  messageThTh: [{
    required: true,
    message: '請輸入泰文顯示訊息',
    trigger: ['blur']
  }],
  messageViVn: [{
    required: true,
    message: '請輸入越南文顯示訊息',
    trigger: ['blur']
  }],
  messageIdId: [{
    required: true,
    message: '請輸入印尼文顯示訊息',
    trigger: ['blur']
  }],
  messageJaJp: [{
    required: true,
    message: '請輸入日文顯示訊息',
    trigger: ['blur']
  }]
};

const showI18nMessageModal = () => {
  if (i18nMessageForm.value != null) {
    i18nMessageForm.value.resetFields();
  }
  isOpen.value = true;
  formTitle.value = props.title;
  formState.messageZhTw = props.message == null ? "" : props.message.messageZhTw;
  formState.messageEnUs = props.message == null ? "" : props.message.messageEnUs;
  formState.messageThTh = props.message == null ? "" : props.message.messageThTh;
  formState.messageViVn = props.message == null ? "" : props.message.messageViVn;
  formState.messageIdId = props.message == null ? "" : props.message.messageIdId;
  formState.messageJaJp = props.message == null ? "" : props.message.messageJaJp;
}

const cancelUpdateMessages = () => {
  isOpen.value = false;
  emit('cancel');
}

const updateMessages = () => {
  i18nMessageForm.value.validate()
  .then(() => {
    isOpen.value = false;
    emit('update-complete', formState);
  }).catch(() => { });
}

</script>
<style scoped>
  button,
  span {
    display: inline-flex;
    align-items: center;
  }
  .input-text-style {
    width: 200px;
  }
</style>